module.exports = __webpack_public_path__ + "img/image-not-available.8e80af38.png";